import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ManageUsersComponent } from './manage-users/manage-users.component';
import { ManageCustomersComponent } from './manage-customers/manage-customers.component';
import { ManageUsersModule } from './manage-users/manage-users.module';
import { ManageCustomersModule } from './manage-customers/manage-customers.module';
import { routes as r1 } from './manage-customers/manage-customers-routing.module';
import { routes as r2 } from './manage-users/manage-users-routing.module';

export const routableModules = [
  ManageCustomersModule
  ,ManageUsersModule
]

export const routes: Routes = [
  {path: 'manage-customers', component: ManageCustomersComponent, children: r1 },
  {path: 'manage-users', component: ManageUsersComponent, children: r2 },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
    ,routableModules
  ],
  exports: [RouterModule]
})
export class AccountsRoutingModule { }
